import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import StatusIndicator from 'components/application/indicators/StatusIndicator';
import Tooltip from 'components/application/Tooltip';

import { getTrainingStatusAndTooltip } from 'components/helpers/resources/training';

export default function CourseTrainingStatusIndicator({ status }) {
  const { t: i18nTTraining } = useTranslation('common', {
    keyPrefix: 'training',
  });

  const trainingStatusAndTooltip = getTrainingStatusAndTooltip({
    status,
    translations: {
      noRequiredTraining: i18nTTraining('noRequiredTraining'),
      requiredTrainingHasExpired: i18nTTraining('requiredTrainingHasExpired'),
      requiredTrainingIsExpiringSoon: i18nTTraining(
        'requiredTrainingIsExpiringSoon',
      ),
      requiredTrainingIsMissing: i18nTTraining('requiredTrainingIsMissing'),
      requiredTrainingIsMissingExpiryDate: i18nTTraining(
        'requiredTrainingIsMissingExpiryDate',
      ),
      trainingIsUpToDate: i18nTTraining('trainingIsUpToDate'),
    },
  });

  return (
    <div className='tooltip-parent tw-flex'>
      <StatusIndicator status={trainingStatusAndTooltip?.status} />
      <Tooltip
        placement='top'
        tooltip={trainingStatusAndTooltip?.tooltip}
        trigger='hover'
      />
    </div>
  );
}

CourseTrainingStatusIndicator.propTypes = {
  status: PropTypes.number.isRequired,
};
